import CustomTimePicker from './CustomTimePicker';

interface CustomTimeRangeProperties {
  inputLabel?: string;
  inputLabel2?: string;
  value1: string;
  value2: string;
  name1: string;
  name2: string;
  onChangeValue: (name: string, value: string | number) => void;
  valueRequired?: boolean;
  readOnly?: boolean;
  error?: boolean;
  // errorMessage?: string;
}

/**
 * Custom time range input fields
 * @param {any} param0 - The param0
 * @param {any} param0.inputLabel - The inputLabel prop
 * @param {any} param0.inputLabel2 - The inputLabel2 prop
 * @param {any} param0.name1 - The name1 prop
 * @param {any} param0.name2 - The name2 prop
 * @param {any} param0.value1 - The value1 prop
 * @param {any} param0.value2 - The value2 prop
 * @param {any} param0.onChangeValue - The onChangeValue prop
 * @param {any} param0.valueRequired - The valueRequired prop
 * @param {any} param0.readOnly - The readOnly prop
 * @param {any} param0.error - The error prop
 */
function CustomTimeRange({
  inputLabel,
  inputLabel2,
  name1,
  name2,
  value1,
  value2,
  onChangeValue,
  valueRequired,
  readOnly,
  error,
  // errorMessage,
}: CustomTimeRangeProperties) {
  /**
   * handle time select
   * @param {any} name - The name
   * @param {any} changeValue - The changeValue
   */
  const handleValueChange = (name: string, changeValue: string | number) =>
    onChangeValue(name, changeValue);

  return (
    <div className="custom-input-time-wrap">
      <div className="custom-label">
        {inputLabel && (
          <p className={`input-label ${error && 'error'}`}>
            {inputLabel}
            {valueRequired && <span>*</span>}
          </p>
        )}
        {inputLabel2 && (
          <p className="input-label">
            {inputLabel2}
            {valueRequired && <span>*</span>}
          </p>
        )}
      </div>
      <div className="custom-time-range-input">
        <CustomTimePicker
          onChangeValue={handleValueChange}
          name={name1}
          value={value1}
          readOnly={readOnly}
          errorHandle={error}
        />
        <CustomTimePicker
          onChangeValue={handleValueChange}
          name={name2}
          value={value2}
          readOnly={readOnly}
          errorHandle={error}
        />
      </div>
      {/* {error && <p className="custom-input-error-message">{errorMessage}</p>} */}
    </div>
  );
}

CustomTimeRange.defaultProps = {
  inputLabel: '',
  inputLabel2: '',
  valueRequired: false,
  readOnly: false,
  error: false,
  // errorMessage: '',
};

export default CustomTimeRange;
